import styled from 'styled-components';
import React from 'react';
export const VersionSection = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 760px;
  background: #fff;
  padding: 32px;
  margin: auto;
  border: 2px solid #d3d3d3;
  border-radius: 4px;
  color: ${(props) => props.theme.navyBlue};
  @media (min-width: 768px) {
    padding: 32px 152px;
  }
`;
export const VersionHeader = styled.h3 `
  text-align: center;
  font-size: 36px;
  font-weight: 800;
  line-height: 45px;
  margin-bottom: 36px;
`;
export const VersionNumberField = styled.p `
  margin: 0;
  font-size: ${(props) => props.theme.fontSmall};
  color: ${(props) => props.theme.darkGray};
  line-height: 1.3125rem;
  margin-top: 8px;
  text-align: center;
`;
export const Version = ({ currentVersion }) => (React.createElement(VersionSection, null,
    React.createElement(VersionHeader, null, "Wersja aplikacji"),
    React.createElement(VersionNumberField, null, currentVersion ? currentVersion : 'Local')));
export default Version;
